"use client";
import { AnalyticsEvent, trackEvent } from "@/lib/analytics";
import type { StripeCardFormInnerProps } from "@/features/stripe/components/StripeCardForm";

type CardCaptureUser = "Patient" | "Staff";

/**
 * Wraps the StripeCardForm submit lifecycle with the SaveCardClicked /
 * SaveCardSucceeded / SaveCardFailed analytics events shared by the patient
 * and staff card capture flows, which differ only by `user`.
 */
export function useCardCaptureAnalytics(
  user: CardCaptureUser,
  patientId: string | null,
  onSuccess: StripeCardFormInnerProps["onSuccess"],
  organizationDisplayName?: string | null,
  organizationLegalName?: string | null,
): Pick<StripeCardFormInnerProps, "onSubmitClick" | "onSuccess" | "onError"> {
  return {
    onSubmitClick: () =>
      trackEvent(AnalyticsEvent.SaveCardClicked, {
        user,
        patient_id: patientId,
        organization_display_name: organizationDisplayName,
        organization_legal_name: organizationLegalName,
      }),
    onSuccess: async (setupIntentId) => {
      trackEvent(AnalyticsEvent.SaveCardSucceeded, {
        user,
        patient_id: patientId,
        organization_display_name: organizationDisplayName,
        organization_legal_name: organizationLegalName,
      });
      await onSuccess(setupIntentId);
    },
    onError: () =>
      trackEvent(AnalyticsEvent.SaveCardFailed, {
        user,
        patient_id: patientId,
        organization_display_name: organizationDisplayName,
        organization_legal_name: organizationLegalName,
      }),
  };
}
